import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./modern-cart-style.css";

const CART_KEY = "cart";
const CART_EXPIRY_KEY = "cart_expiry";


export default function SuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/"); // ⛔️ 非法访问
      return;
    }

    const payload = {
      session_id: sessionId,
      user_agent: navigator.userAgent,
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      viewport_size: `${window.innerWidth}x${window.innerHeight}`,
      referrer: document.referrer || null
    };

    // fetch(`${process.env.REACT_APP_API_URL}/verify-session?session_id=${sessionId}`, {
    fetch(`${process.env.REACT_APP_API_URL}/verify-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload)
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.detail || "Unknown error");
        }
        return res.json();
      })
      .then((data) => {
        if (data.status === "success") {
          setUserInfo({
            email: data.email,
            camper_name: data.camper_name,
            phone_number: data.phone_number,
            receipt_url: data.receipt_url,
            payment_method: data.payment_method,
            payment_intent_status: data.payment_intent_status,
          });
    
          localStorage.removeItem(CART_KEY);
          localStorage.removeItem(CART_EXPIRY_KEY);
    
          // // ✅ 可选：隐藏 session_id（美化 URL）
          // window.history.replaceState({}, "", "/success");
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        console.error("⚠️ verify-session error:", err);
        alert("Could not verify your payment session: " + err.message);
        navigate("/");
      })
      .finally(() => setLoading(false));
  }, [location, navigate]);

  if (loading || !userInfo) return null;

  const isBankTransfer = userInfo.payment_method === "us_bank_account";

  return (
    <div className="container" style={{ textAlign: "center", padding: "60px 20px" }}>
      <div className="confirmation-card">
        {/* ✅ 动态显示不同的图标 */}
        <div style={{
          width: "80px",
          height: "80px",
          margin: "0 auto 20px",
          borderRadius: "50%",
          backgroundColor: isBankTransfer ? "#f4c10f" : "#2ecc71",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          {isBankTransfer ? (
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 22h14" />
            <path d="M5 2h14" />
            <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
            <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
          </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </div>


        {/* ✅ 动态显示标题 */}
        <h2 style={{ fontSize: "28px", marginBottom: "20px", color: isBankTransfer ? "#f4c10f" : "#2ecc71" }}>
          {isBankTransfer ? "Payment Processing" : "Payment Successful"}
        </h2>

        {/* ✅ 动态正文 */}
        <p style={{ fontSize: "18px", color: "#333", marginBottom: "24px", lineHeight: "1.6" }}>
          {isBankTransfer ? (
            <>
              Your bank transfer is being processed. It may take 2-5 business days to complete.
              <br />
              A confirmation email will be sent to{" "}
              <span style={{ fontWeight: "bold", color: "#222" }}>{userInfo.email}</span> once completed.
            </>
          ) : (
            <>
              A receipt from Stripe has been sent to{" "}
              <span style={{ fontWeight: "bold", color: "#222" }}>{userInfo.email}</span>.
              <br />
              You can also view your receipt from below.
              <br />
              (Print to save as PDF).
            </>
          )}
        </p>

        {/* ✅ 只有不是Bank Transfer才显示Receipt按钮 */}
        {!isBankTransfer && userInfo.receipt_url && (
          <a
            href={userInfo.receipt_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              width: "240px",
              backgroundColor: "#f4c10f",
              color: "#222",
              padding: "12px 28px",
              borderRadius: "6px",
              textDecoration: "none",
              textAlign: "center",
              fontWeight: "bold",
              display: "inline-block",
              marginBottom: "24px",
            }}
          >
            View Receipt
          </a>
        )}

        {/* ✅ 下面照常显示用户信息 */}
        <p style={{ fontSize: "18px", color: "#333", marginBottom: "24px", lineHeight: "1.6" }}>
          Below is the entered camper information:
          <br />
          <div style={{ fontSize: "16px", color: "#444", marginBottom: "30px" }}>
            {userInfo.camper_name && <p><strong>Camper Name(s)<br/></strong> {userInfo.camper_name}</p>}
            {userInfo.phone_number && <p><strong>Phone:</strong> {userInfo.phone_number}</p>}
          </div>
          If anything is incorrect, please contact 
          <a
            href="mailto:connectedbasketball@gmail.com"
            style={{ color: "#f4c10f", textDecoration: "underline", marginLeft: "5px" }}
          >
            connectedbasketball@gmail.com
          </a> for support.
        </p>

        <button
          className="checkout-btn"
          style={{ padding: "12px 28px", fontSize: "16px" }}
          onClick={() => navigate("/")}
        >
          Return to Store
        </button>
      </div>
    </div>
  );
}

/* 加一个简单CSS动画在你的modern-cart-style.css里，供Loader转圈用 */
/* 放在modern-cart-style.css最后加这个 */
// @keyframes spin {
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// }
